// extracted by mini-css-extract-plugin
export var feed__item = "Feed-module--feed__item--16FdI";
export var feed__itemTitle = "Feed-module--feed__item-title--2qrxW";
export var feed__itemTitleLink = "Feed-module--feed__item-title-link--hq_ve";
export var feed__itemDescription = "Feed-module--feed__item-description--1cUJz";
export var feed__itemMetaTime = "Feed-module--feed__item-meta-time--2vlrR";
export var feed__itemMetaDivider = "Feed-module--feed__item-meta-divider--1mzzc";
export var feed__itemMetaCategoryLink = "Feed-module--feed__item-meta-category-link--QOsPP";
export var feed__itemReadmore = "Feed-module--feed__item-readmore--a2w13";